export * from "./NewMCEntity";
